// Central configuration — replace the WhatsApp number here to update it site-wide.
export const WHATSAPP_NUMBER = "919813856526";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const discoveryMessage = ({ name, concern, goal }) =>
  `Hi Dr. Anjali, I have completed the Aarogyam Bharat Discovery Call form.

My name is ${name}.

My main health concern is ${concern}.

My main health goal is ${goal}.

I would like to understand which coaching pathway may be suitable for me.`;

export const COMMUNITY_MESSAGE =
  "Hi Dr. Anjali, I would like to join the Aarogyam Bharat WhatsApp community for practical health tips, nutrition education and workshop updates.";

export const GENERAL_MESSAGE =
  "Hi Dr. Anjali, I visited the Aarogyam Bharat website and would like to know more about your health coaching.";
